module.exports = __webpack_public_path__ + "static/img/年节活动@2x (2).cfab285.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/年节活动@2x (2).png
// module id = aABo
// module chunks = 1